import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";

import { CameraType } from "..";
import { renderActions, type RenderState, selectCameraType } from "../renderSlice";

export function useSetController() {
    const dispatch = useAppDispatch();
    const cameraType = useAppSelector(selectCameraType);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(
        (value: RenderState["cameraDefaults"]["pinhole"]["controller"]) => {
            dispatch(renderActions.setCameraDefaults({ pinhole: { controller: value } }));

            if (cameraType === CameraType.Pinhole) {
                // Trigger new controller
                dispatch(renderActions.setCamera({ type: CameraType.Pinhole }));
            }
        },
        [dispatch, cameraType],
    );
}
